import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import { selectFocusedPoiId } from '../../store/geoentity/geoentity.selectors'
import { selectIsMapFullScreen } from '../../store/map/map.selectors'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { isUIElementDisplayed } from '../../store/ui/ui.selectors'
import UserArea from '../UserAccount/UserArea'
import UserAccountIncentivePopin from '../UserAccount/connectionIncentive/UserAccountIncentivePopin'
import UtiqLoader from '../advertising/UtiqLoader'
import CMPPlaceholder from '../cmp/CMPPlaceholder'
import AlertBanner from '../cms/AlertBanner'
import MenuCategoriesGE from '../menu/MenuCategoriesGE'
import Outdoor from '../outdoor/Outdoor'
import { createCustomSelector } from '../utils/react-reselect'

const selectCommonClasses = createCustomSelector(
  selectIsMapFullScreen,
  isUIElementDisplayed(UI_ELEMENTS.POPIN),
  isUIElementDisplayed(UI_ELEMENTS.SUGGEST),
  isUIElementDisplayed(UI_ELEMENTS.MENU_PE),
  isUIElementDisplayed(UI_ELEMENTS.MAP_TOOLS_PE),
  selectFocusedPoiId,
  (isMapFullScreen, isPopinDisplayed, isSuggestDisplayed, isMenuPEDisplayed, isMapToolsPEDisplayed, hasFocusedPoi) => [
    isMapFullScreen && PAGE_CLASSES.withFullscreenMap,
    isPopinDisplayed && PAGE_CLASSES.withDetail,
    isSuggestDisplayed && PAGE_CLASSES.withSuggest,
    isMenuPEDisplayed && PAGE_CLASSES.withMenuPEDisplayed,
    isMapToolsPEDisplayed && PAGE_CLASSES.withMapToolsPEDisplayed,
    hasFocusedPoi && PAGE_CLASSES.withPoiPopinDisplayed
  ]
)

const defaultPageClassManagerResult = [] // That constant is important to serve same array reference between calls ; it avoid reselect warnings
const defaultPageClassManager = () => defaultPageClassManagerResult

const Page = ({ cssClasses = [], children, ...props }) => {
  const commonClasses = useSelector(selectCommonClasses)
  const pageClassManager = props?.pageClassManager ?? defaultPageClassManager
  const pageSpecificClasses = useSelector(pageClassManager)
  const className = classNames(...cssClasses, ...commonClasses, ...pageSpecificClasses)

  return (
    <div className={className}>
      <CMPPlaceholder key="CMPPlaceholder" />
      <UtiqLoader key="UtiqLoader" />
      <Outdoor />
      <MenuCategoriesGE />
      <UserArea />
      <UserAccountIncentivePopin />
      <AlertBanner />
      {children}
    </div>
  )
}

export default Page
